import { useEffect, useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";

const H = 64;

// Compact bottom bar for phones. Shows once the hero has scrolled away; pads the body so nothing is covered
// and publishes --sv-sticky-h so the cookie banner can sit above it.
export function MobileStickyCta({ label, price, onClick, disabled, loading, testId = "mobile-sticky-cta", showAfter = 420, note }) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onScroll = () => setShown(mq.matches && window.scrollY > showAfter);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    mq.addEventListener("change", onScroll);
    return () => { window.removeEventListener("scroll", onScroll); mq.removeEventListener("change", onScroll); };
  }, [showAfter]);
  useEffect(() => {
    const root = document.documentElement;
    if (shown) { root.style.setProperty("--sv-sticky-h", `${H}px`); document.body.classList.add("sv-has-sticky-cta"); }
    else { root.style.removeProperty("--sv-sticky-h"); document.body.classList.remove("sv-has-sticky-cta"); }
    return () => { root.style.removeProperty("--sv-sticky-h"); document.body.classList.remove("sv-has-sticky-cta"); };
  }, [shown]);
  if (!shown) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] border-t border-purple-500/40 bg-[#07050b]/95 backdrop-blur-md md:hidden" style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }} data-testid={testId} role="region" aria-label="Purchase">
      <div className="flex h-16 items-center gap-3 px-4">
        <div className="min-w-0 flex-1">
          <div className="truncate text-xs font-semibold text-zinc-200" data-testid={`${testId}-label`}>{label}</div>
          {note && <div className="truncate text-xs text-zinc-500">{note}</div>}
        </div>
        <button type="button" onClick={onClick} disabled={disabled || loading} className="inline-flex min-h-11 shrink-0 items-center gap-2 bg-purple-500 px-5 text-xs font-black uppercase tracking-[0.18em] text-black transition-colors hover:bg-purple-400 disabled:opacity-50" data-testid={`${testId}-button`}>
          {loading ? <Loader2 size={14} className="animate-spin" aria-hidden="true" /> : null}{price}{!loading && <ArrowRight size={14} aria-hidden="true" />}
        </button>
      </div>
    </div>
  );
}
